<template>
    <div class="photo">
		<div class="photo-place">
            <div class="photo-place__wrap">
                <LinceIconArrowLeft
                    v-if="isSliderModeShow"
                    class="photo-place__arrow photo-place__arrow_left"
                    @click.native="toPrevPhoto"
                />

                <BaseIcon
                    v-if="photoSmall === '-'"
                    icon="icon-tabler-icon-camera"
                    style="color: #ccc;"
                />
                <img
                    v-if="photoSmall !== '-'"
                    :src="photoCurrentMiddle"
                    @click="openPopup"
                >

                <LinceIconArrowRight
                    v-if="isSliderModeShow"
                    class="photo-place__arrow photo-place__arrow_right"
                    @click.native="toNextPhoto"
                />

                <div
                    v-if="isSliderModeShow"
                    class="photo-place__pagination"
                >
                    <div
                        v-for="paginationIndex in photoList.length"
                        :key="paginationIndex"
                        :class="{'photo-place__pagination-item_active' : getIsPaginationItemActive(paginationIndex)}"
                        class="photo-place__pagination-item"
                    />
                </div>
            </div>
			<PopupWindow
                v-if="photoSmall !== '-'"
				v-show="isPopupVisible"
				@close="closePopup"
                class="popup-window"
			>
                <LinceIconArrowLeft
                    v-if="isSliderModeShow"
                    class="photo-place__arrow photo-place__arrow-popup photo-place__arrow_left photo-place__arrow-popup_left"
                    @click.native="toPrevPhoto"
                />

				<div class="popup-window__wrapper">
					<img :src="photoCurrentBig">
				</div>

                <LinceIconArrowRight
                    v-if="isSliderModeShow"
                    class="photo-place__arrow photo-place__arrow-popup photo-place__arrow_right photo-place__arrow-popup_right"
                    @click.native="toNextPhoto"
                />
			</PopupWindow>
        </div>
	</div>
</template>

<script>
import PopupWindow from "@/components/Popup";
import BaseIcon from "@/components/Base/BaseIcon";

export default {
	name: "Photo",
    components: {
        PopupWindow,
        BaseIcon
    },
    props: {
        photoSmall: {
            type: String,
            default: ""
        },
        photoBig: {
            type: String,
            default: ""
        },
        isSliderMode: {
            type: Boolean,
            default: false
        },
        photoList: {
            type: Array,
            default: () => ([])
        }
    },
    data: () => ({
        isPopupVisible: false,
        photoCurrentIndex: 0
    }),
    computed: {
        isSliderModeShow() {
            return this.isSliderMode && this.photoList.length > 1;
        },
        photoCurrent() {
            return this.photoList[this.photoCurrentIndex] ?? {};
        },
        photoCurrentMiddle() {
            return this.isSliderMode ? this.photoCurrent.middle : this.photoSmall;
        },
        photoCurrentBig() {
            return this.isSliderMode ? this.photoCurrent.big : this.photoBig;
        }
    },
    methods: {
        openPopup() {
            this.isPopupVisible = true
        },
        closePopup() {
            this.isPopupVisible = false
        },
        getIsPaginationItemActive(paginationIndex) {
            return this.photoCurrentIndex === paginationIndex - 1;
        },
        toPrevPhoto() {
            if (this.photoCurrentIndex > 0)
                this.photoCurrentIndex -= 1;
            else
                this.photoCurrentIndex = this.photoList.length - 1;
        },
        toNextPhoto() {
            if (this.photoCurrentIndex < this.photoList.length - 1)
                this.photoCurrentIndex += 1;
            else
                this.photoCurrentIndex = 0;
        },
    }
}
</script>

<style lang="scss" scoped>
.photo {
    border-radius: 4px;
    overflow: hidden;

    &-place {
        width: 100%;
        height: 100%;
        position: relative;

        &__wrap {
            position: absolute;
            top: 0px;
            left: 0px;
            bottom: 0px;
            right: 0px;
            background: #fafafa;
            align-items: center;
            display: flex;
            justify-content: center;

            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                cursor: pointer;
            }
        }

        &__pagination {
            position: absolute;
            top: 90%;
            // top: 105%;
            width: 100%;
            display: flex;
            justify-content: center;

            &-item {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                // background: #fff;
                background: #cbcbcb;

                &:not(:last-child) {
                    margin-right: 5px;
                }

                &_active {
                    background: #1f79d2;
                }
            }
        }

        &__arrow {
            position: absolute;
            z-index: 1;
            cursor: pointer;

            ::v-deep {
                path {
                    fill: #fff;
                }
            }

            &:hover {
                ::v-deep {
                    path {
                        fill: #1f79d2;
                    }
                }
            }

            &-popup {
                width: 50px;
                height: 50px;
                cursor: pointer;

                &_left {
                    top: 50%;
                    left: 20px !important;
                }

                &_right {
                    top: 50%;
                    right: 20px !important;
                }
            }

            &_left {
                left: 0;
            }

            &_right {
                right: 0;
            }
        }
    }
}

.popup-window {
    &__wrapper {
        padding: 15px;
        background: #fff;
    }

    img {
        max-width: 800px;
        max-height: 80vh;
        display: block;
    }
}
</style>
